<template>
  <div class="verification-container">
    <AppLogo />
    <PageHeader>Создать аккаунт</PageHeader>
    <form @submit.prevent="continueVerification">
      <InputField type="text" v-model="emailCode" placeholder="Код из email"/>
      <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
      <button type="submit" class="continue-button">Продолжить</button>
      <InstructionHelp>Введите код, отправленный на вашу почту</InstructionHelp>
      <p>
        <span @click="resendCode" class="resend-link">Отправить код заново</span>
      </p>
    </form>
  </div>
</template>

<script>
import AppLogo from "@/components/auth/AppLogo.vue";
import PageHeader from "@/components/auth/PageHeader.vue";
import InputField from "@/components/auth/InputField.vue";
import InstructionHelp from "@/components/auth/InstructionHelp.vue";
import { sendVerificationCode, verifyCode } from "@/utils/emailVerification";

export default {
  components: { InstructionHelp, InputField, PageHeader, AppLogo },
  name: 'RegistrationByEmail',
  data() {
    return {
      emailCode: '',
      errorMessage: ''
    };
  },
  computed: {
    email() {
      return localStorage.getItem('email');
    }
  },
  created() {
    if (!this.email) {
      this.errorMessage = 'Ошибка: электронная почта отсутствует';
    }
  },
  methods: {
    async continueVerification() {
      const verified = await verifyCode(this.email, this.emailCode);
      if (verified) {
        localStorage.setItem('isVerified', 'true');
        this.$router.push('/register');
      } else {
        this.errorMessage = 'Неверный код';
      }
    },
    async resendCode() {
      this.errorMessage = '';
      const sent = await sendVerificationCode(this.email);
      if (!sent) {
        this.errorMessage = 'Не удалось повторно отправить код';
      }
    },
  },
};

</script>

<style scoped>
.verification-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

.continue-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
}

.continue-button:hover {
  background-color: #333;
}

.resend-link {
  text-decoration: underline;
  color: #000;
  cursor: pointer;
  display: block;
  text-align: left;
}

.error {
  color: red;
}
</style>
